import React from "react";  

const Unauthorized = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 text-white text-center p-6">
      <h1 className="text-6xl font-extrabold mb-4">🚫 Access Denied!</h1>
      <p className="text-xl mb-6 max-w-lg">
        Whoa there, secret agent! 🕵️‍♂️ You’ve stumbled into a restricted zone.  
        Only the chosen ones get past this point… and sadly, that’s not you (yet 😉).
      </p>
      <button
        onClick={() => window.history.back()}
        className="bg-white text-purple-700 font-semibold px-6 py-3 rounded-full shadow-lg hover:bg-purple-100 transition duration-300"
      >
        🔙 Take Me Back
      </button>
    </div>
  );
};

export default Unauthorized;
